import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon, Typography } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
  SCREEN_SIZE_MOBILE_XLARGE,
  SCREEN_WIDTH_QUERIES,
} from '../../../../../utils/constant';
import SpbTimeLine from '../SpbTimeLine';

import './SimpleAccordion.css';

const PAD = {
  sod: 'sod',
  privileges: 'privileges',
};

function SimpleAccordion({
  title,
  children,
  isInitialOpen,
  iconKind = 'Entitlement',
  kind,
  pad,
}) {
  const { mediaQueryValue } = useSelector(
    (state) => state?.certifications?.details?.global
  );

  const mobileXlargeQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_MOBILE_XLARGE
  );
  const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;

  const accordianBodyClasses = classnames(
    'SimpleAccordion-body',
    isMobileWidth && 'SimpleAccordion-body--mobileResponsive'
  );

  const accordianHeaderClasses = classnames(
    'SimpleAccordion-header',
    isMobileWidth && 'SimpleAccordion-header--mobileResponsive'
  );

  const [isOpen, setIsOpen] = useState(isInitialOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={
        pad === PAD.privileges
          ? 'SimpleAccordion--privileges'
          : 'SimpleAccordion--sod'
      }>
      <div
        className={accordianHeaderClasses}
        onClick={toggleAccordion}
        onKeyUp={() => {}}
        role='button'
        tabIndex={0}>
        <div className='SimpleAccordion-headerTitle'>
          <SpbTimeLine
            iconKind={iconKind}
            kind={kind}
            type='fill'
            showTail={false}
            dataTestId='SimpleAccordion-SpbTimeLine'
          />
          <Typography
            kind='h4'
            className={
              isOpen
                ? 'SimpleAccordion-headerTitleText--expanded'
                : 'SimpleAccordion-headerTitleText--closed'
            }>
            {title}
          </Typography>
        </div>
        <div
          className={
            isOpen
              ? 'SimpleAccordion-headerIcon--open'
              : 'SimpleAccordion-headerIcon--closed'
          }>
          <Icon kind='ChevronDown' size='small' color='neutral-800' />
        </div>
      </div>
      {isOpen && <div className={accordianBodyClasses}>{children}</div>}
    </div>
  );
}

SimpleAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  iconKind: PropTypes.string,
  kind: PropTypes.string,
  isInitialOpen: PropTypes.bool,
  pad: PropTypes.oneOf(Object.values(PAD)),
};

SimpleAccordion.defaultProps = {
  iconKind: 'Entitlement',
  kind: 'list',
  isInitialOpen: false,
  pad: PAD.sod,
};

export default SimpleAccordion;
